import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppThemeProvider } from './styles/ThemeModeContext';
import { GlobalStyle } from './styles/GlobalStyle';

import { AuthProvider } from './auth/AuthContext';
import { ActiveAccountProvider } from './account/ActiveAccountContext';
import { ProtectedRoute } from './routes/ProtectedRoute';
import { DialogProvider } from './shared/dialog/DialogProvider';

import { AuthLayout } from './shared/layouts/AuthLayout';
import { AppLayout } from './shared/layouts/AppLayout';
import { RouteEffects } from './shared/layouts/RouteEffects';

import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import AccountPage from './pages/AccountPage';
import SettingsPage from './pages/SettingsPage';
import BoardPage from './pages/BoardPage';
import ProductsPage from './pages/ProductsPage';
import PrivacyPolicyPage from './pages/legal/PrivacyPolicyPage';
import DataDeletionPage from './pages/legal/DataDeletionPage';

export default function App() {
  return (
    <AppThemeProvider>
      <GlobalStyle />
      <DialogProvider>
        <BrowserRouter>
          <RouteEffects />
          <AuthProvider>
            <ActiveAccountProvider>
              <Routes>
                <Route element={<AuthLayout />}>
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                </Route>

                <Route path="/privacy" element={<PrivacyPolicyPage />} />
                <Route path="/data-deletion" element={<DataDeletionPage />} />

                <Route element={<ProtectedRoute />}>
                  <Route element={<AppLayout />}>
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/board" element={<BoardPage />} />
                    <Route path="/products" element={<ProductsPage />} />
                    <Route path="/account" element={<AccountPage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                    <Route
                      path="/tone"
                      element={<Navigate to="/account" replace />}
                    />
                    <Route
                      path="/speech"
                      element={<Navigate to="/account" replace />}
                    />
                    <Route
                      path="/create"
                      element={<Navigate to="/board" replace />}
                    />
                    <Route
                      path="/posts"
                      element={<Navigate to="/board" replace />}
                    />
                  </Route>
                </Route>

                <Route
                  path="/"
                  element={<Navigate to="/board" replace />}
                />
                <Route
                  path="*"
                  element={<Navigate to="/board" replace />}
                />
              </Routes>
            </ActiveAccountProvider>
          </AuthProvider>
        </BrowserRouter>
      </DialogProvider>
    </AppThemeProvider>
  );
}
